import { Notify, Report, Confirm, Block } from 'notiflix';

// https://notiflix.github.io/documentation

Notify.init({
  showOnlyTheLastOne: true,
  cssAnimationStyle: 'from-right',
  fontFamily: '"Roboto", "sans-serif"',
  fontSize: '16px',
  plainText: false,
  success: {
    background: '#22830c',
  },
  failure: {
    background: '#CA2A2D',
  },
  info: {
    background: '#1c73c7',
  },
  useFontAwesome: true,
});

Report.init({
  backOverlayColor: 'rgba(0,0,0,0.5)',
  messageFontSize: '16px',
  borderRadius: '6px',
  fontFamily: '"Roboto", "sans-serif"',
  titleFontSize: '20px',
  plainText: false,
  width: '400px',
  success: {
    backOverlayColor: '',
    svgColor: '#22830c',
    buttonBackground: '#22830c',
  },
  failure: {
    backOverlayColor: '',
    svgColor: '#CA2A2D',
    buttonBackground: '#CA2A2D',
  },
  warning: {
    backOverlayColor: '',
  },
});

Confirm.init({
  position: 'center-top',
  titleColor: '#501214',
  titleFontSize: '20px',
  fontFamily: '"Roboto", "sans-serif"',
  borderRadius: '6px',
  okButtonBackground: '#22830c',
  cancelButtonBackground: '#595959',
  plainText: false,
  messageMaxLength: 400,
});

Block.init({
  fontFamily: '"Roboto", "sans-serif"',
  messageFontSize: '24px',
  backgroundColor: '#DDD5C9',
  svgColor: '#7A1B1E',
});

const affirmWithEnter = (event) => {
  const confirmButton = document.getElementById('NXConfirmButtonOk');
  const cancelButton = document.getElementById('NXConfirmButtonCancel');
  if (event.key === 'Enter' && confirmButton) {
    confirmButton.click();
  } else if (event.key === 'Escape' && cancelButton) {
    cancelButton.click();
  }
  document.removeEventListener('keydown', affirmWithEnter);
};

// Notiflix automatically listens for 'Enter' on prompt, so just listen for Escape
// Looks like this only affects Confirm.prompt, and NOT Confirm.show
const cancelWithEscape = (event) => {
  const cancelButton = document.getElementById('NXConfirmButtonCancel');
  if (event.key === 'Escape' && cancelButton) {
    cancelButton.click();
  }
  document.removeEventListener('keydown', cancelWithEscape);
};

export const notify = {
  saved: (options = {}) => {
    Notify.success('Saved', options);
  },
  success: (message, options) => {
    Notify.success(message || 'Success', options);
  },
  failure: (message, options) => {
    Notify.failure(message || 'Something went wrong', options);
  },
  info: (message, options) => {
    Notify.info(message || 'Working on it...', options);
  },
  alertSuccess: (title, message, optionalCallback) => {
    Report.success(title, message || 'Success', 'Okay', optionalCallback);
  },
  alertFailure: (title, message, optionalCallback) => {
    Report.failure(
      title,
      message || 'Something went wrong...',
      'Close',
      optionalCallback
    );
  },
  alertWarning: (title, message, optionalCallback) => {
    Report.warning(title, message, 'Okay', optionalCallback);
  },
};

export const confirmation = {
  destroy: (proceedCallback) => {
    document.addEventListener('keydown', affirmWithEnter);
    Confirm.show(
      'Confirm Delete',
      'Are you sure you want to do this?',
      'Delete',
      'Cancel',
      () => proceedCallback(),
      function cancelCallback() {},
      {
        okButtonBackground: '#CA2A2D',
      }
    );
  },
  copy: (proceedCallback) => {
    document.addEventListener('keydown', affirmWithEnter);
    Confirm.show(
      'Confirm Copy',
      'Are you sure you want to do this?',
      'Copy',
      'Cancel',
      () => proceedCallback(),
      function cancelCallback() {}
    );
  },
  prompt: (title, text, placeholder, proceedCallback) => {
    document.addEventListener('keydown', cancelWithEscape);
    Confirm.prompt(
      title,
      text,
      placeholder,
      'Continue',
      'Cancel',
      (input) => proceedCallback(input),
      function cancelCallback(input) {}
    );
  },
  acknowledge: (
    yesCallback,
    noCallback,
    title = 'Are you sure?',
    msg = '',
    yesBtn = 'Yes',
    noBtn = 'No'
  ) => {
    document.addEventListener('keydown', affirmWithEnter);
    Confirm.show(
      title,
      msg,
      yesBtn,
      noBtn,
      () => yesCallback(),
      () => noCallback()
    );
  },
};

export const loadingBlock = {
  add: (elementSelector, message = '') => {
    Block.hourglass(elementSelector, message);
  },
  remove: (elementSelector) => {
    Block.remove(elementSelector);
  },
};
